module.exports = __webpack_public_path__ + "img/icon02.a2aa1b4.png";